import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/app/PageBits";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PauseRequests() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const load = async () => setList((await api.get("/pause-requests", { params: { status: "pending" } })).data);
  useEffect(() => { load(); }, []);

  const decide = async (id, decision) => {
    try { await api.post(`/pause-requests/${id}/decide`, { decision }); toast.success(decision); load(); }
    catch(e){ toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div>
      <PageHeader title="Pause / free-period approvals" subtitle="Admins raise these; Super Admin decides. During pause, invoice generation is skipped entirely."/>
      <div className="border border-border rounded-md bg-card overflow-hidden">
        <table className="w-full text-sm m-cards">
          <thead className="bg-muted/60"><tr className="text-left">
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Plot</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Customer</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">From</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">To</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Reason</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Status</th>
            <th className="px-4 py-3"></th>
          </tr></thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} data-testid={`pause-row-${r.id}`} className="border-t border-border">
                <td className="px-4 py-3 font-medium">{r.plot_no}</td>
                <td className="px-4 py-3">{r.customer_name}</td>
                <td className="px-4 py-3 tabular">{fmtDate(r.start_date)}</td>
                <td className="px-4 py-3 tabular">{fmtDate(r.end_date)}</td>
                <td className="px-4 py-3 text-muted-foreground truncate max-w-xs">{r.reason || "-"}</td>
                <td className="px-4 py-3"><StatusBadge status={r.status}/></td>
                <td className="px-4 py-3 text-right flex gap-1 justify-end">
                  {user?.role === "super_admin" ? (
                    <>
                      <Button data-testid={`approve-pause-${r.id}`} size="sm" onClick={()=>decide(r.id,"approved")}>Approve</Button>
                      <Button data-testid={`reject-pause-${r.id}`} size="sm" variant="outline" onClick={()=>decide(r.id,"rejected")}>Reject</Button>
                    </>
                  ) : <span className="text-xs text-muted-foreground">Awaiting Super Admin</span>}
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground">Nothing pending.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
